// extracted by mini-css-extract-plugin
export default {"assestsRoot":"BalanceHeader_assestsRoot__-tQ-9","balanceHeaderTitle":"BalanceHeader_balanceHeaderTitle__aXn3I"};